module.exports = __webpack_public_path__ + "static/media/title_gameinfo.89c54bd3.png";